import React from 'react';

import PageTitle from 'Components/PageTitle';
import image from 'common/assets/images/error.png';
import Button from '../Button';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: 'Something went wrong.' };
  }

  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
    this.setState((state) => ({ ...state, error: error.toString() }));
    console.log(error, info);
  }

  onReload = () => {
    window.localStorage.clear();
    window.location = window.location.origin;
  };

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div style={{ padding: '5%' }}>
          <PageTitle>
            {this.state.error}
            .
            <br />
            Please, reload the page.
          </PageTitle>
          <Button
            maxWidth="120px"
            mt={20}
            ml="auto"
            mr="auto"
            type="primary"
            onClick={this.onReload}
          >
            Reload
          </Button>

          <img className="fullImg" src={image} alt="Logo" />
        </div>
      );
    }

    return this.props.children;
  }
}
